import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ladeIdentitaeten,
  selectIdentitaetenStatus,
} from 'modules/identitaeten/features/identitaetenSlice';
import { pruefeTresorStatus, selectTresorStatus } from 'core/features/sicherheit/sicherheitSlice';
import { projectVisited } from 'core/features/projects/projectsSlice';
import GesichertHinweis from 'core/features/sicherheit/GesichertHinweis';

/**
 * Absicherung fuer alle Identitaeten-Seiten: rendert die Inhalte nur im
 * gesicherten Modus (entsperrter Tresor). Beim Entsperren werden die
 * Identitaeten einmalig geladen.
 */
export default function GesichertGate({ children }) {
  const dispatch = useDispatch();
  const tresorStatus = useSelector(selectTresorStatus);
  const status = useSelector(selectIdentitaetenStatus);
  const kryptoVerfuegbar = typeof window !== 'undefined' && window.crypto && window.crypto.subtle;

  useEffect(() => {
    if (!kryptoVerfuegbar) return;
    dispatch(projectVisited('identitaeten'));
    dispatch(pruefeTresorStatus());
  }, [dispatch, kryptoVerfuegbar]);

  useEffect(() => {
    if (tresorStatus !== 'unlocked' || status !== 'idle') return;
    dispatch(ladeIdentitaeten());
  }, [tresorStatus, status, dispatch]);

  if (!kryptoVerfuegbar) return <GesichertHinweis bereich="Der Identitäten-Bereich" />;
  if (tresorStatus === 'unknown') return <p className="text-center text-ink-muted">Lade…</p>;
  if (tresorStatus !== 'unlocked') return <GesichertHinweis bereich="Der Identitäten-Bereich" />;
  return children;
}
